import React from 'react';
import { useDispatch } from 'react-redux';

import Box from '@mui/material/Box';

import { handleMenuItemClick } from 'bento-ordering/menus/actions';
import { setScrollPosition } from 'bento-ordering/base/actions/scrollManager';
import { MENU } from 'bento-ordering/menus/constants/entities';
import { useGetMenuPopularItemsNotInCart } from 'bento-ordering/menus/selectors/index';
import MenuSectionHeader from 'components/Menu/MenuSectionHeader';
import MenuSectionList from 'bento-ordering/menus/components/MenuSectionList';

const POPULAR_ITEMS_TITLE = 'Popular items';

const MenuPopularItems = () => {
  const dispatch = useDispatch();
  const popularItems = useGetMenuPopularItemsNotInCart();

  const handleClick = slug => {
    dispatch(setScrollPosition(MENU, window.pageYOffset));
    return dispatch(handleMenuItemClick(slug));
  };

  return (
    <>
      {!!popularItems.length && (
        <Box id="popular-items" mb={1}>
          <MenuSectionHeader title={POPULAR_ITEMS_TITLE} isFirst />
          <MenuSectionList
            menuList={popularItems}
            handleClick={handleClick}
            shouldLazyLoadMenu={false}
            isExpanded
          />
        </Box>
      )}
    </>
  );
};

export default MenuPopularItems;
